import { Route } from '@angular/router';
import { featureFlagGuard } from 'app/core/guards/feature-flag.guard';
import { FEATURE_FLAGS } from 'app/core/services/feature-flag.service';
import { LayoutComponent } from 'app/layout/layout.component';

/**
 * Public landing routes (no NoAuthGuard) so authenticated users can still open
 * invitation accept / help / pricing without bouncing to signed-in-redirect.
 */
export const publicLandingRoutes: Route = {
    path: '',
    component: LayoutComponent,
    data: {
        layout: 'empty',
    },
    children: [
        {
            path: 'errors',
            loadChildren: () => import('app/features/error/error.routes'),
        },
        {
            path: 'content',
            loadChildren: () =>
                import('app/features/public/content/content.routes'),
        },
        {
            path: 'pricing',
            loadChildren: () =>
                import('app/features/public/pricing/pricing.routes'),
            // Plan catalog + subscribe/Stripe checkout: part of billing, so
            // behind pfl-billing like /billing (mvp-release-scope §5.2).
            canActivate: [featureFlagGuard(FEATURE_FLAGS.BILLING)],
        },
        // Stripe Checkout returns to /billing/checkout/success|cancel (auth billing
        // module). Legacy /plans/billing/* redirects there. VNPay removed.
        {
            // Must NOT use 'support' — owned by admin support-chat.
            path: 'help',
            loadChildren: () => import('app/features/public/support/routes'),
        },
        {
            path: 'invitations/accept',
            loadChildren: () =>
                import(
                    'app/features/public/invitation-accept/invitation-accept.routes'
                ),
        },
        {
            // kb#2254 — customer support-session confirmation link. Separate
            // from 'support' (admin tickets mount) and 'help' (public chat).
            path: 'support-session/confirm',
            loadComponent: () =>
                import(
                    'app/features/public/support-session/pages/confirm-session-page/support-session-confirm.component'
                ).then((m) => m.SupportSessionConfirmComponent),
        },

        // PhotoQA (T5.8): moved to its own single top-level `/photoqa` mount
        // in `app.routes.ts` — see `features/photoqa/photoqa.routes.ts`.
    ],
};
